import React, { useState, useEffect } from 'react';
import { Table, Button, Form, InputGroup, Spinner, Card, Row, Col } from 'react-bootstrap';
import { FaSearch, FaEdit, FaPlus, FaUser,  } from 'react-icons/fa';
import profissionaisService from '../../api/profissionaisService';
import { useNavigate, useParams } from 'react-router-dom';
import { NotificationContext } from '../../contexts/notification-context';

const ListarProfissionais = () => {
  const { addNotification } = React.useContext(NotificationContext);
  const [profissionais, setProfissionais] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busca, setBusca] = useState('');
  const navigate = useNavigate();

  const fetchProfissionais = async () => {
    setLoading(true);
    try {
      const response = await profissionaisService.listar();
      setProfissionais(response);
    } catch (error) {
      console.error('Erro ao buscar profissionais:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfissionais();
  }, []);

  const handleSearch = (e) => {
    setBusca(e.target.value);
  };

  const profissionaisFiltrados = profissionais?.filter((profissional) =>
    profissional?.nome?.toLowerCase().includes(busca.toLowerCase())
  );

  const handleEdit = (id) => {
    navigate(`/profissionais/${id}`);
  };

  const handleNewProfissional = () => {
    navigate('/profissionais');
  };

  return (
    <div className="listar-profissionais-container">
      <Card className="shadow-sm">
        <Card.Body>
          <Card.Title className="text-center mb-4">Lista de Profissionais</Card.Title>
          <hr />
          <Row>
            <Col md={9} className="mb-3">
              <Form>
                <InputGroup>
                  <Form.Control
                    type="text"
                    placeholder="Buscar profissional por nome..."
                    value={busca}
                    onChange={handleSearch}
                  />
                  <InputGroup.Text>
                    <FaSearch />
                  </InputGroup.Text>
                </InputGroup>
              </Form>
            </Col>
            <Col md={3} className="text-end">
              <Button variant="success" onClick={handleNewProfissional}>
                <FaPlus /> Novo Profissional
              </Button>
            </Col>
          </Row>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" />
            </div>
          ) : (
            <Table striped bordered hover responsive className="mb-0">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Especialidade</th>
                  <th>E-mail</th>
                  <th>Externo</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {profissionaisFiltrados?.map((profissional) => (
                  <tr key={profissional.id}>
                    <td>{profissional.nome}</td>
                    <td>{profissional.especialidade?.nome}</td>
                    <td>{profissional.email}</td>
                    <td>{profissional.externo ? "Sim" : "Não"}</td>
                    <td>
                      <Button
                        style={{ backgroundColor: '#840027', borderColor: '#840027' }}
                        size="sm"
                        onClick={() => handleEdit(profissional.id)}
                      >
                        <FaEdit /> Editar
                      </Button>
                    </td>
                    <td>
                      <Button
                        style={{ backgroundColor: '#840027', borderColor: '#840027' }}
                        size="sm"
                        onClick={() => handleEdit(profissional.id)}
                      >
                        <FaUser /> Editar
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default ListarProfissionais;